"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRefreshDetails = exports.getAfpDetails = exports.getBidderDetails = exports.getIxSiteId = exports.isValidAdPlacement = exports.isPlacementDisabled = void 0;
var adzerkHeaderBiddingUnitMap_1 = require("../ads-growth/ads-service/config/adzerkHeaderBiddingUnitMap");
var adPlacements_1 = require("../ads-growth/ads-service/config/adPlacements");
var isValidAdPlacement = function (placement) {
    return Object.values(adPlacements_1.adPlacements).includes(placement);
};
exports.isValidAdPlacement = isValidAdPlacement;
var isPlacementDisabled = function (placement) {
    var unitMeta = adzerkHeaderBiddingUnitMap_1.adzerkHeaderBiddingUnitMap[placement];
    return !!(unitMeta === null || unitMeta === void 0 ? void 0 : unitMeta.isDisabled);
};
exports.isPlacementDisabled = isPlacementDisabled;
var getIxSiteId = function (placement) {
    var unitMeta = adzerkHeaderBiddingUnitMap_1.adzerkHeaderBiddingUnitMap[placement];
    return unitMeta === null || unitMeta === void 0 ? void 0 : unitMeta.ixSiteId;
};
exports.getIxSiteId = getIxSiteId;
var getBidderDetails = function (placement) {
    var unitMeta = adzerkHeaderBiddingUnitMap_1.adzerkHeaderBiddingUnitMap[placement];
    return {
        rubiconZone: unitMeta === null || unitMeta === void 0 ? void 0 : unitMeta.rubiconZone,
        pubmaticSlot: unitMeta === null || unitMeta === void 0 ? void 0 : unitMeta.pubmaticSlot,
        tripleliftInvCode: unitMeta === null || unitMeta === void 0 ? void 0 : unitMeta.tripleliftInvCode,
        sovrnTag: unitMeta === null || unitMeta === void 0 ? void 0 : unitMeta.sovrnTag,
        sharethroughPKey: unitMeta === null || unitMeta === void 0 ? void 0 : unitMeta.sharethroughPKey,
        "33acrossSiteId": unitMeta["33acrossSiteId"],
    };
};
exports.getBidderDetails = getBidderDetails;
var getAfpDetails = function (placement) {
    var unitMeta = adzerkHeaderBiddingUnitMap_1.adzerkHeaderBiddingUnitMap[placement];
    var afpDetails = {
        googleChannelId: unitMeta === null || unitMeta === void 0 ? void 0 : unitMeta.googleChannelId,
        googleAdSlot: unitMeta === null || unitMeta === void 0 ? void 0 : unitMeta.googleAdSlot,
        googleMarkupFormat: unitMeta === null || unitMeta === void 0 ? void 0 : unitMeta.googleMarkupFormat,
    };
    if (!afpDetails.googleChannelId ||
        !afpDetails.googleAdSlot ||
        !afpDetails.googleMarkupFormat) {
        return undefined;
    }
    return afpDetails;
};
exports.getAfpDetails = getAfpDetails;
var getRefreshDetails = function (placement) {
    var unitMeta = adzerkHeaderBiddingUnitMap_1.adzerkHeaderBiddingUnitMap[placement];
    var refreshDetails = {
        refreshAd: unitMeta === null || unitMeta === void 0 ? void 0 : unitMeta.refreshAd,
        refreshRate: unitMeta === null || unitMeta === void 0 ? void 0 : unitMeta.refreshRate,
        maxRefreshes: unitMeta === null || unitMeta === void 0 ? void 0 : unitMeta.maxRefreshes,
    };
    if (!refreshDetails.refreshAd) {
        return undefined;
    }
    return refreshDetails;
};
exports.getRefreshDetails = getRefreshDetails;
